var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "生成报价单",
            visible: _vm.dialog,
            width: _vm.getIsMobile ? "100%" : "70%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.handleClose,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.list, border: "" } },
            [
              _c("el-table-column", {
                attrs: { label: "序号", prop: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.$index + 1) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "型号", prop: "xhname" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input", {
                          attrs: { type: "text", placeholder: "请输入型号" },
                          model: {
                            value: row.xhname,
                            callback: function ($$v) {
                              _vm.$set(row, "xhname", $$v)
                            },
                            expression: "row.xhname",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "品牌", prop: "source" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input", {
                          attrs: { type: "text", placeholder: "请输入品牌" },
                          model: {
                            value: row.source,
                            callback: function ($$v) {
                              _vm.$set(row, "source", $$v)
                            },
                            expression: "row.source",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "数量", prop: "num" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var $index = ref.$index
                      return [
                        _c("el-input", {
                          staticClass: "{ 'input-error': errors[$index] }",
                          attrs: { type: "text", placeholder: "请输入数量" },
                          on: {
                            blur: function ($event) {
                              return _vm.validateRow($index, row.num)
                            },
                          },
                          model: {
                            value: row.num,
                            callback: function ($$v) {
                              _vm.$set(row, "num", _vm._n($$v))
                            },
                            expression: "row.num",
                          },
                        }),
                        _vm.errors[$index]
                          ? _c("span", { staticClass: "error-text" }, [
                              _vm._v("数量为必填项"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "单价", prop: "price" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(" " + _vm._s(row.price) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "默认", prop: "renshui" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-select",
                          {
                            on: {
                              change: function ($event) {
                                return _vm.updatePrices(row)
                              },
                            },
                            model: {
                              value: row.renshui,
                              callback: function ($$v) {
                                _vm.$set(row, "renshui", $$v)
                              },
                              expression: "row.renshui",
                            },
                          },
                          _vm._l(_vm.percentOptions, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "货期", prop: "hq" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input", {
                          attrs: { type: "text", placeholder: "请输入货期" },
                          model: {
                            value: row.hq,
                            callback: function ($$v) {
                              _vm.$set(row, "hq", $$v)
                            },
                            expression: "row.hq",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "备注", prop: "bz" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input", {
                          attrs: { type: "text", placeholder: "请输入备注" },
                          model: {
                            value: row.bz,
                            callback: function ($$v) {
                              _vm.$set(row, "bz", $$v)
                            },
                            expression: "row.bz",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "价格来源", prop: "address" },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-top": "8px" },
              attrs: { type: "primary" },
              on: { click: _vm.openCompany },
            },
            [_vm._v("选择报价公司")]
          ),
          _vm.showInfo
            ? _c(
                "el-card",
                { staticStyle: { "margin-top": "10px" } },
                [
                  _c("Info", {
                    ref: "infoRef",
                    attrs: {
                      companyInfo: _vm.companyInfo,
                      allInfo: _vm.allInfo,
                    },
                    on: {
                      handleContact: _vm.getContact,
                      handleFlag: _vm.handleFlag,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.showInfo
            ? _c(
                "el-button",
                {
                  staticStyle: { "margin-top": "8px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.printQuotation },
                },
                [_vm._v("打印报价单")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择报价公司",
            visible: _vm.showCompany,
            width: _vm.getIsMobile ? "100%" : "70%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.handleClose,
            "append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCompany = $event
            },
          },
        },
        [_c("QuotationCompany", { on: { selectedCompany: _vm.getCompany } })],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择公司联系人",
            visible: _vm.showCompanyContact,
            width: _vm.getIsMobile ? "100%" : "80%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.handleCompanyContactClose,
            "append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCompanyContact = $event
            },
          },
        },
        [
          _vm.showCompanyContact
            ? _c("CompanyContacts", {
                ref: "contactRef",
                attrs: { data: _vm.companyContact },
                on: {
                  quotationContact: _vm.getSelectContacts,
                  getFirstContact: _vm.getFirstContact,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.flag
        ? _c("CompanyContacts", {
            ref: "contactRef",
            attrs: { data: _vm.companyContact },
            on: {
              quotationContact: _vm.getSelectContacts,
              getFirstContact: _vm.getFirstContact,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }